import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.to-string.js";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ThemeSectionError = /*#__PURE__*/function (_Error) {
  _inherits(ThemeSectionError, _Error);
  var _super = _createSuper(ThemeSectionError);
  function ThemeSectionError() {
    _classCallCheck(this, ThemeSectionError);
    return _super.apply(this, arguments);
  }
  return _createClass(ThemeSectionError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export default ThemeSectionError;